<template>
    <div v-if="Object.keys(this.$store.getters.fusions).length>0" style="margin-bottom:20px;">
        <v-table v-for="(item,k) in this.$store.getters.fusions"  v-bind:key="k" class="elevation-1 table table-striped tb-variants">
            <thead>
                <tr style="background-color:#f0f0f0;padding:10px;text-align:left;">
                    <th>
                        Location
                    </th>
                    <th>
                        Frameshift
                    </th>
                    <th>
                        Details
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        {{k}}
                    </td>
                    <td>
                        {{ item.UTA_Adapter_fusion.is_inframe }}
                    </td>
                    <td>
                        <router-link style="text-decoration:none;"
                            :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-fusion-details/${ k }`
                            }"
                        >
                            <v-btn>
                                Details
                                <v-icon icon="mdi-chevron-right"></v-icon>
                            </v-btn>
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </v-table>
    </div>
</template>
<script>

export default {
    methods: {
    },
    mounted: async function() {
    }
}
</script>

<style scoped>

td {
    text-align: left;
}

</style>